import React from "react";

import WrappedPage from "./src/components/WrappedPage";
import WrappedRoot from "./src/components/WrappedRoot";

// custom typefaces
import "@fontsource/tajawal";
import "@openfonts/tajawal_arabic";

export const wrapPageElement = WrappedPage;
export const wrapRootElement = WrappedRoot;
